export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61577930107463";
export const MESSENGER_URL = "https://m.me/61577930107463";
export const BOOKING_URL = "https://rkez-oldal.vibepreview.com/foglalas";

export const STUDIO = {
  name: "TestLélekHarmónia Masszázs Stúdió",
  owner: "Takácsné Kiss Rita",
  address: "Tököl, Csépi út 114",
  contactNote: "Telefonon és Facebook Messengeren keresztül történik",
  practitioners: [
    { name: "Takácsné Kiss Rita", phone: "+36704324269", phoneDisplay: "06 70 / 432-4269" },
    { name: "Zólyominé Felner Annamária", phone: "+36307153708", phoneDisplay: "06 30 / 715-3708" },
  ],
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_88c14f9c-fd95-4806-b5c3-16e17737eab4/artifacts/gae1w2xk_UNWI5710.JPG";
export const COVER_URL =
  "https://customer-assets.emergentagent.com/job_88c14f9c-fd95-4806-b5c3-16e17737eab4/artifacts/fwk57t5m_IMG_3822.JPG";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const MAGNETS = [
  {
    key: "sport",
    badge: "Sportolóknak",
    title: "Regenerációs Kisokos",
    subtitle: "Sport után – mély izomvédelem",
    description:
      "4Life prémium termékek tájékoztatója és a masszázs jótékony hatásainak bemutatása — célzottan sportolóknak.",
    bullets: [
      "Pontos nyújtó- és önmasszázs fogások",
      "4Life termék tájékoztató sportolóknak",
      "A masszázs jótékony hatásai a regenerációban",
    ],
    accent: "#2A9D8F",
    icon: "Dumbbell",
  },
  {
    key: "suli",
    badge: "Szülőknek & Gyerekeknek",
    title: "Suli-hát és Nyugi Zóna",
    subtitle: "5 könnyű gyakorlat a stressz ellen",
    description:
      "Mozgásos gyakorlatok szülőknek és gyerekeknek az iskolai hátterhelés és a mindennapi stressz oldására.",
    bullets: [
      "5 percnyi reggeli átmozgatás",
      "Hátfájás-megelőzés iskolásoknak",
      "Esti nyugi-rituálé család együtt",
    ],
    accent: "#D4AF37",
    icon: "GraduationCap",
  },
  {
    key: "aroma",
    badge: "Mindennapra",
    title: "Aroma Flow – 3 Tipp",
    subtitle: "Stresszoldás illatokkal",
    description:
      "Stresszoldó illat/nyugi buborék recept, gyors átmozgás légzéstechnikával, autós és tömegközlekedős minikártyák. A masszázson Te választhatod ki, milyen illatú olajjal történjen a kezelés.",
    bullets: [
      "Nyugi-buborék illórecept",
      "60 másodperces légzéstechnika",
      "Útközben is használható kártyák",
    ],
    accent: "#1C6B61",
    icon: "Sparkles",
  },
];

export const MASSAGES = [
  {
    key: "suli-hat",
    title: "Suli-hát és Nyugi Zóna Masszázs",
    short: "Fiataloknak és szülőknek",
    ageGroup: "Gyerek",
    duration: "30 perc",
    description:
      "Kifejezetten a fiatalok és szülők testi-lelki feltöltődésére, a hátfájás és a mindennapi stressz enyhítésére. Lágy, biztonságos érintés, korhoz igazított protokollal.",
    benefits: [
      "Iskolai hátfeszültség oldása",
      "Vizsgaidőszaki stressz csökkentése",
      "Anya/Apa-időpont a feltöltődéshez",
    ],
    accent: "#1C6B61",
    prices: [
      { label: "Sima alkalom (30 perc)", price: "2 500 Ft" },
    ],
    vip4Price: "10 000 Ft / hó",
    vip8Price: null,
  },
  {
    key: "hat-nyak-vall",
    title: "Hát-Nyak-Váll Lazító Masszázs",
    short: "Klasszikus, célzott feszültségoldás",
    ageGroup: "Felnőtt",
    duration: "60 perc",
    description:
      "A legnépszerűbb klasszikus kezelés a mindennapi ülőmunka, tanulás és stressz okozta izommerevség gyors enyhítésére. Mély, célzott fogásokkal oldjuk fel a vállövet és a felső háti régiót.",
    benefits: [
      "Fej- és nyaki fájdalom csökkentése",
      "Vállövi mobilitás visszaállítása",
      "Felfrissült energia és tisztább fókusz",
    ],
    accent: "#2A9D8F",
    prices: [
      { label: "30 perc sima alkalom", price: "5 000 Ft" },
      { label: "60 perc sima alkalom", price: "9 000 Ft" },
      { label: "5 alkalmas bérlet", price: "43 000 Ft" },
    ],
    vip4Price: "34 400 Ft / hó",
    vip8Price: "68 800 Ft / hó",
  },
  {
    key: "aroma-flow",
    title: "Aroma Flow Masszázs",
    short: "Prémium illóolajos arc + hátmasszázs",
    ageGroup: "Felnőtt",
    duration: "45 perc",
    description:
      "Prémium illóolajos, mély relaxációs és feszültségoldó kezelés a teljes harmóniáért. Arc + hát kombinált munka lágy, áramló érintéssel — a kezelés előtt Te választhatod ki, milyen illatú olajjal szeretnéd a kezelést.",
    benefits: [
      "Vendég-választott illatú olaj",
      "Idegrendszer megnyugtatása",
      "Mélypihenés és alváskvalitás javulás",
    ],
    accent: "#D4AF37",
    prices: [
      { label: "45 perc sima alkalom", price: "7 500 Ft" },
    ],
    vip4Price: "26 000 Ft / hó",
    vip8Price: "52 000 Ft / hó",
  },
  {
    key: "premium-relax",
    title: "Prémium Relax Masszázs",
    short: "Luxus kategória · hetente választható",
    ageGroup: "Felnőtt",
    duration: "60 perc",
    description:
      "Luxus kategóriás kezelés, ahol minden héten szabadon választhatsz a Herballabdacsos vagy a 60 perces meleg Gyertyás Thermo és a Detox-Duó masszázsaim közül. VIP tagsághoz szabott, változatos élmény.",
    benefits: [
      "Herballabdacsos, Thermo vagy Detox-Duó – Te választasz",
      "Prémium alapanyagok, exkluzív protokollok",
      "Változatos, sosem monoton élmény",
    ],
    accent: "#A88A2B",
    prices: [],
    vipOnly: true,
    vip4Price: "40 000 Ft / hó",
    vip8Price: "80 000 Ft / hó",
  },
  {
    key: "sport-masszazs",
    title: "Sport Masszázs",
    short: "Aktív sportolóknak, mélymunka",
    ageGroup: "Felnőtt",
    duration: "60 perc",
    description:
      "Edzések közötti és utáni regenerációhoz: célzott mély izommunka, izomláz-oldás és az izomtónus helyreállítása. Versenyzők és aktívan mozgók kedvence.",
    benefits: [
      "Izomláz és merevség oldása",
      "Gyorsabb regeneráció edzés után",
      "Sérülés-megelőzés célzott fogásokkal",
    ],
    accent: "#2A9D8F",
    prices: [
      { label: "60 perc sima alkalom", price: "12 000 Ft" },
    ],
    vip4Price: "40 000 Ft / hó",
    vip8Price: "80 000 Ft / hó",
  },
  {
    key: "teljes-test",
    title: "Teljes Test Masszázs",
    short: "Klasszikus vagy meleg Gyertyás Thermo",
    ageGroup: "Felnőtt",
    duration: "75 perc",
    description:
      "Az egész testet átölelő, klasszikus svéd alapú kezelés. Választhatod a 75 perces meleg Gyertyás Thermo masszázst is – a fejtől talpig ellazulás egy órán túl.",
    benefits: [
      "Teljes testi-lelki feltöltődés",
      "Vérkeringés és nyirokáramlás támogatása",
      "Klasszikus vagy Gyertyás Thermo – Te választasz",
    ],
    accent: "#D4AF37",
    prices: [
      { label: "75 perc sima alkalom", price: "15 000 Ft" },
    ],
    vip4Price: "48 000 Ft / hó",
    vip8Price: "96 000 Ft / hó",
  },
];

export const FOURLIFE_PRODUCTS = [
  {
    key: "gyerek-csaladi",
    title: "4Life Gyerek és Családi Vitaminok",
    tagline: "Mindennapi vitalitás · Suli-szezon",
    description:
      "Prémium minőségű általános vitaminok és kifejezetten gyermekeknek szánt immunerősítő megoldások a mindennapi vitalitásért és a suli-szezonra való felkészülésre.",
    highlights: [
      "Transfer Factor® támogatás",
      "Iskoláskor immun-felkészülés",
      "Egész család egy csomagban",
    ],
    accent: "#2A9D8F",
  },
  {
    key: "izulet",
    title: "4Life Ízületvédő Csomag",
    tagline: "Hosszú távú mobilitás",
    description:
      "A hosszú távú mobilitásért, aktív mozgásszabadságért és az ízületek védelméért. Bevizsgált összetevők, természetes alapokon.",
    highlights: [
      "Kollagén + glükózamin",
      "Gyulladáscsökkentő támogatás",
      "Aktív sportolók kedvence",
    ],
    accent: "#D4AF37",
  },
  {
    key: "sport-energia",
    title: "4Life Sport és Energia Csomag",
    tagline: "Természetes regeneráció",
    description:
      "Természetes energiatámogatás, vitalitás és gyorsabb regeneráció sportolóknak. Edzés előtt és után is használható.",
    highlights: [
      "Edzés előtti energia",
      "Edzés utáni regeneráció",
      "Tisztán természetes alapok",
    ],
    accent: "#1C6B61",
  },
];

// Forever Arc- és Szépségápolás oldal (CMS-ből szerkeszthető)
export const FOREVER_PILLARS = [
  {
    title: "Tisztítás",
    text: "Kíméletesen eltávolítja a szennyeződést és a felesleges faggyút – a bőr védőrétegének kímélésével.",
  },
  {
    title: "Tonizálás",
    text: "Összehúzza a pórusokat, helyreállítja a bőr pH-egyensúlyát, és felkészíti a hatóanyagok befogadására.",
  },
  {
    title: "Hidratálás",
    text: "Mélyen táplál és feltölt, hogy a bőr rugalmas, sima és ragyogó maradjon egész nap.",
  },
];

export const FOREVER_PACKAGES = [
  {
    key: "tiszta-bor-kamasz",
    accent: "#2A9D8F",
    title: "Tiszta Bőr Kamasz Csomag",
    tagline: "Viszlát, bőrhibák!",
    articleKey: "borapolas-szinergia",
    description: "Egyszerű, 3 lépéses rutin tinédzsereknek a pattanások és a zsíros bőr ellen, felesleges szárítás nélkül.",
    contents: ["Aloe Liquid Soap", "Aloe First", "Aloe Propolis Creme", "Aloe Vera Gelly"],
    benefit: "Mélyen tisztít, megnyugtatja a gyulladt, piros bőrt, és természetes módon akadályozza meg az újabb pattanások kialakulását.",
  },
  {
    key: "ragyogo-noi-arcapolas",
    accent: "#A88A2B",
    title: "Ragyogó Női Arcápolási Csomag",
    tagline: "A Te mindennapi luxusod",
    articleKey: "borapolas-szinergia",
    description: "Prémium, anti-aging és mélyhidratáló rutin a sugárzó, feszes és élettel teli bőrért.",
    contents: ["Logic by Forever termékcsalád", "Nappali krém", "Éjszakai krém"],
    benefit: "24 órás sejtszintű védelmet és táplálást biztosít. Nappal véd a környezeti ártalmaktól, éjszaka pedig intenzíven regenerál és feltölt.",
  },
  {
    key: "csaladi-test-szepsegapolas",
    accent: "#1C6B61",
    title: "Családi Test- és Szépségápolási Csomag",
    tagline: "A fürdőszoba sztárjai",
    articleKey: "borapolas-szinergia",
    description: "Tiszta, biztonságos és prémium tisztálkodási alapcsomag a legkisebbektől a legnagyobbakig.",
    contents: ["Body Wash", "Body Lotion", "Shampoo", "Jojoba Balzsam", "Deodorant", "Aloe First", "Aloe Lips"],
    benefit: "Kiváltja a fürdőszobai vegyszereket. Hidratálja a bőrt, ápolja a hajat, alumíniummentes védelmet ad, a First és Lips duó pedig az egész család azonnali elsősegélycsomagja (csípésekre, horzsolásokra).",
  },
];


// Kiemelt csomag-tájékoztatók a 4Life oldalon (CMS-ből szerkeszthető)
export const FOURLIFE_HIGHLIGHTS = [
  {
    key: "kids",
    cover: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1000&q=70",
    badge: "Gyerekeknek · Suli-szezon",
    accent: "#2A9D8F",
    title: "Erős immunrendszer az iskolakezdésre",
    intro:
      "A zárt közösségek őszi „slágerei” – a megfázás, orrfolyás és köhögés – nem kötelezőek. A 4Life Transfer Factor termékek nem sima vitaminok: olyan transzfer faktorokat tartalmaznak, amelyek szó szerint „megtanítják” a gyerek immunrendszerét a fenyegetések gyorsabb felismerésére és legyőzésére. Íme a gyerekek őszi kedvencei:",
    products: [
      {
        name: "Transfer Factor Chewable",
        text: "Finom, citrusos ízű rágótabletta, amit a gyerekek imádnak – nincs több lenyelhetetlen kapszula. Tökéletes alap a mindennapi védelemhez.",
      },
      {
        name: "Transfer Factor RioVida Stix",
        text: "Egy tasaknyi antioxidáns- és immunbomba. Csak keverd a kulacsba vagy a reggeli vízbe – bogyós ízű, védi a sejteket és hidratál is.",
      },
      {
        name: "Transfer Factor Classic",
        text: "A tiszta, jól bevált formula az érzékenyebb szervezetű vagy fiatalabb gyerekeknek – a legbiztosabb mindennapi alap.",
      },
    ],
    articleTo: "/blog?article=vitaminok-suliszezon",
    articleLabel: "Elolvasom a teljes cikket",
  },
  {
    key: "izulet",
    cover: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=1000&q=70",
    badge: "Ízületvédelem · 30+",
    accent: "#A88A2B",
    title: "Ízületvédő csomag – hosszú távú mobilitás",
    intro:
      "Az ízületeid 30 felett tudatos védelmet kérnek. Ez a páros belülről táplálja a porcot, az inakat és a kötőszövetet – hogy a mozgás hosszú távon is szabad és fájdalommentes maradjon.",
    products: [
      {
        name: "Kollagén",
        text: "A porc, az inak és a kötőszövet fő építőanyaga, amelynek természetes termelődése 30 felett lassul. A célzott pótlás megőrzi az ízületek rugalmasságát és a szövetek ellenállóképességét.",
      },
      {
        name: "AMJ (ízületvédő formula)",
        text: "Glükózamin és kondroitin, kiegészítve természetes gyulladáscsökkentő növényi kivonatokkal (kurkuma, Boswellia). „Kenést” ad az ízületeknek és csillapítja a mindennapi mikrogyulladásokat.",
      },
    ],
    articleTo: "/blog?article=izulet-mobilitas",
    articleLabel: "Elolvasom az ízületvédelem cikket",
  },
  {
    key: "sport-energia",
    cover: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1000&q=70",
    badge: "Sportolóknak · Természetes regeneráció",
    accent: "#1C6B61",
    title: "Sport és energia csomag – tiszta, sejtszintű támogatás",
    intro:
      "Felejtsd el a cukros energiaitalokat és a műanyag ízű zseléket. Ez a csomag tiszta, sejtszintű támogatást ad az edzés minden fázisában – az előkészítéstől a regenerációig.",
    products: [
      {
        name: "Energy Go Stix",
        text: "Természetes koffeinforrások (guarana, zöld tea) + L-Arginin: éles fókusz és jobb oxigénellátás hirtelen „összeomlás” nélkül – hogy tovább és kímélőbben mozogj.",
      },
      {
        name: "RioVida Burst – természetes sport gél",
        text: "Antioxidáns-bomba tiszta gyümölcspépből (açaí, áfonya, gránátalma). Gyomorbarát, egyenletes energiát ad, és teljesen koffeinmentes – az esti alvásodat sem rontja el.",
      },
      {
        name: "AMJ + Kollagén",
        text: "Az ízületek és a kötőszövet védelme a terhelés alatt: kevesebb kopás, gyorsabb regeneráció és fájdalommentesebb másnapok.",
      },
      {
        name: "TF Booster (Transfer Factor)",
        text: "Az immunrendszer okos „edzője” – a kemény terhelés utáni egyensúlyért és a hatékonyabb regenerációért.",
      },
    ],
    articleTo: "/regeneracios-kisokos",
    articleLabel: "Megnézem a Regenerációs Kisokost",
  },
];


// Blog placeholders
export const BLOG_ARTICLES = [
  {
    key: "vitaminok-suliszezon",
    title: "Vitaminok a suli-szezonra: amit minden szülő tudjon",
    excerpt:
      "Az iskolakezdés a gyerekeknek és szülőknek egyaránt nagy terhelés. Hogyan készítsük fel az immunrendszert természetesen?",
    body: "",
    date: "2026. március",
    category: "Vitaminok",
    cover: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=900&q=70",
  },
  {
    key: "hat-nyugalom-otthon",
    title: "5 önmasszázs fogás otthonra a megfáradt hátnak",
    excerpt:
      "Egyszerű, eszköz nélkül kivitelezhető technikák a mindennapi feszültség enyhítésére – akár ülőmunka közben is.",
    body: "",
    date: "2026. február",
    category: "Masszázs tippek",
    cover: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=900&q=70",
  },
  {
    key: "izulet-mobilitas",
    title: "Ízületvédelem 30+: amit ma kezdj el",
    excerpt:
      "A mozgásszabadság hosszú távú megőrzéséhez nem kell extrém edzés – csak következetesség.",
    body: "",
    date: "2026. január",
    category: "4Life megoldások",
    cover: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=900&q=70",
  },
];

export const BLOG_VIDEOS = [
  {
    key: "video-reggeli-mozgas",
    title: "5 perces reggeli átmozgatás – család együtt",
    duration: "5 perc",
    cover: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=900&q=70",
    facebook_url: "",
  },
  {
    key: "video-suli-hat",
    title: "Suli-hát szabadító – iskolásoknak",
    duration: "7 perc",
    cover: "https://images.unsplash.com/photo-1599447421416-3414500d18a5?w=900&q=70",
    facebook_url: "",
  },
  {
    key: "video-nyugi-este",
    title: "Esti nyugi-rituálé légzéstechnikával",
    duration: "6 perc",
    cover: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=900&q=70",
    facebook_url: "",
  },
];


export const TESTIMONIALS = [
  {
    key: "petra",
    name: "Farkas-Fehérvári Petra",
    tag: "Herballabdacsos masszázs",
    text: "Rita ez fantasztikus volt, jót relaxáltam meg be is aludtam 🤣 Már amikor beléptem a helyiségbe éreztem a gyógynövények nyugtató kellemes illatát, emellé szólt az andalító zene és a te elbűvölő személyiséged és érintésed. Épp ilyen esős napra való relax 💗 Köszönöm szépen 💚",
    accent: "#2A9D8F",
  },
  {
    key: "gabriella",
    name: "Gabriella Krocskó",
    tag: "Bérletes vendég",
    text: "Szia Rita! Nagyon szépen köszönöm az újbóli hátmasszázst. Bérletesként csak ajánlani tudlak másoknak és már alig várom, hogy kipróbáljam nálad az említett lábmasszázst 😍 Jövő héten találkozunk a megbeszélt időpontban. Puszi",
    accent: "#D4AF37",
  },
  {
    key: "orsolya",
    name: "Orsolya Bartha",
    tag: "34 év után visszatérő vendég",
    text: "Szia, jól éreztem magam, kicsit befáradtam utána 😊 be is jelentkeztem megint. Igen, anyukádhoz jártam kb. 16 évesen, a mai napig emlékszem rá 34 év távlatából. Lehet, Ő is emlékszik rám, sikerült meglepnem kb. 2-szer 🤣 Kommentelek majd nektek, de már ajánlottalak is.",
    accent: "#1C6B61",
  },
];
